import React, { Component } from "react";
import "../style/entrance.scss";
import LogOutIcon from "../icon/LogOutIcon";
import LeftBar from "./common/LeftBar";
import HamburgerIcon from "../icon/HamburgerIcon";
import AllowRight from "../icon/AllowRight";
import cookie from "react-cookies";
import {
  BrowserRouter as Router,
  Switch,
  HashRouter,
  Route,
  Redirect,
} from "react-router-dom";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import Story from "./Story";
import Comment from "./Comment";
import AddStory from "./AddStory";
import AddComment from "./AddComment";
import Category from "./Category";
import { setAPIAuthorizationToken } from "../apis/API";

class Entrance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reduce: false,
      username: "",
    };
    this.routeLogin = this.routeLogin.bind(this);
    this.clickReduce = this.clickReduce.bind(this);
  }

  componentDidMount() {
    let param = cookie.load("token");
    if (param) {
      console.log(param);
      this.setState({ username: param.username });
      setAPIAuthorizationToken(param.token);
    } else {
      const { history } = this.props;
      history.push("/Login");
    }
  }

  clickReduce() {
    this.setState({ reduce: !this.state.reduce });
  }
  searchInput(e) {
    this.setState({ searchValue: e.target.value });
  }
  routeLogin() {
    const { history } = this.props;
    cookie.remove("token");
    history.push("/Login");
    window.dispatchEvent(
      new CustomEvent("showAlert", {
        detail: "已成功退出登录",
      }),
    );
  }

  render() {
    const { reduce, username } = this.state;
    return (
      <React.Fragment>
        <div className="body-container">
          {/* 左 */}
          <div className={`left-bar ${reduce ? "reduce-left" : ""}`}>
            <LeftBar {...this.props} />
          </div>
          {/* 右 */}
          <div className={`right-bar ${reduce ? "reduce-right" : ""}`}>
            <header>
              <div className="head-bar">
                <div className="nav-header">
                  <div className="header-left">
                    {reduce ? (
                      <AllowRight
                        size={30}
                        color="#696cff"
                        onClick={this.clickReduce}
                      />
                    ) : (
                      <HamburgerIcon
                        size={30}
                        color="#696cff"
                        onClick={this.clickReduce}
                      />
                    )}
                  </div>
                  <div className="header-right">
                    <div className="profile">
                      <div className="left">
                        <div className="user-text">
                          <p>Hi,</p>
                          <h6>{username}</h6>
                        </div>
                      </div>
                      {/* logout */}
                      <div className="logout" onClick={this.routeLogin}>
                        <LogOutIcon
                          size={28}
                          color="#696cff"
                          className="logout-icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="page-contain">
              <Switch>
                <Route
                  path="/Comment"
                  render={(props) => (
                    <Comment key={props.match.params.id} {...props} />
                  )}
                />
                <Route path="/AddComment" component={AddComment}></Route>
                <Route path="/AddStory" component={AddStory}></Route>
                <Route path="/Story" component={Story}></Route>
                <Route path="/Category" component={Category}></Route>
                <Redirect exact to="/Story" />
              </Switch>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Entrance;
